var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEuroIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 12,
    viewBox: "0 0 10 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.792 12C5.656 12 4.67733 11.744 3.856 11.232C3.04 10.72 2.408 10.0133 1.96 9.112C1.51733 8.20533 1.28533 7.168 1.264 6C1.29067 4.79467 1.528 3.744 1.976 2.848C2.424 1.94667 3.056 1.248 3.872 0.752C4.688 0.250667 5.66133 0 6.792 0C7.34133 0 7.86933 0.0693331 8.376 0.207999C8.888 0.341333 9.36267 0.544 9.8 0.816L8.776 2.408C8.49867 2.21067 8.18667 2.06133 7.84 1.96C7.49867 1.85867 7.14933 1.808 6.792 1.808C6.01333 1.808 5.368 1.984 4.856 2.336C4.34933 2.688 3.96533 3.18133 3.704 3.816C3.448 4.44533 3.31733 5.17333 3.312 6C3.31733 6.84267 3.45067 7.57867 3.712 8.208C3.97333 8.83733 4.36 9.32533 4.872 9.672C5.38933 10.0187 6.02933 10.1893 6.792 10.184C7.53867 10.2 8.20533 10.0027 8.792 9.592L9.8 11.168C9.36267 11.4453 8.88533 11.6533 8.368 11.792C7.856 11.9307 7.33067 12 6.792 12ZM0 8.096V6.584H7.568V8.096H0ZM0 5.432V3.92H7.568V5.432H0Z",
    fill: "#01152E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEuroIcon);
export default __webpack_public_path__ + "static/media/euro-icon.10c35f1349320a9353283d0e451d6c9d.svg";
export { ForwardRef as ReactComponent };